import { render, staticRenderFns } from "./Notificacoes.vue?vue&type=template&id=1d264aae&scoped=true&"
import script from "./Notificacoes.vue?vue&type=script&lang=js&"
export * from "./Notificacoes.vue?vue&type=script&lang=js&"
import style0 from "./Notificacoes.vue?vue&type=style&index=0&id=1d264aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d264aae",
  null
  
)

export default component.exports